import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';

interface Payload extends AuthModel.PasscodeRequest {
  passcode: string;
}
interface Response {
  isVerified: boolean;
}

/**
 * 전달받은 인증코드를 인증
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/user-sign-controller/verifyPasscode_1
 * @param payload
 * @returns
 */
export default function postVerifyPassCode(payload: Payload) {
  return API.post<Response>('/api/v3/users/passcode/verify', { data: payload }, true);
}
